<template>
  <aside class="left-panel">
    <div class="first-nav hidden-nav">
      <nav class="navbar-default">
        <div @click="shrinkMenu()" class="mainLogo">
          <img class="mainLogoImg is-link" src="@/assets/imgs/trax-daisy-logo.png">
        </div>
        <div class="subMenu" v-for="nav in navItems" :key="nav.id">
          <span @click="selected = nav.route" :class="{'active': nav.route == selected }">
            <router-link :to="nav.route">
              <i :class="nav.icon"></i>
              {{nav.name}}
            </router-link>
          </span>
        </div>
      </nav>
      <nav>
        <div class="subMenu">
          <span>
            <router-link to="/logout">
              <i class="fas fa-sign-out-alt"></i>Logout
            </router-link>
          </span>
        </div>
      </nav>
    </div>
  </aside>
</template>
<script>
export default {
  data () {
    return {
      selected: this.$route.fullPath,
      active: false,
      navItems: [
        { name: 'DashBoard', route: '/', icon: 'fa fa-tachometer-alt' },
        { name: 'Reports', route: '/reports/offers', icon: 'fa fa-chart-bar ' },
        { name: 'Offers', route: '/offers', icon: 'fa fa-square' },
        { name: 'Sets', route: '/sets', icon: 'fa fa-grip-horizontal' },
        { name: 'Users', route: '/users', icon: 'fas fa-users' }
      ]
    }
  },
  mounted () {
    this.resizeWatch()
  },
  destroyed () {
    this.resizeWatch()
  },
  methods: {
    shrinkMenu (option) {
      let menu = document.querySelector('.left-panel')
      let shortMenu = 65
      let bigMenu = 235
      let menuWidth = menu.clientWidth
      return menuWidth === bigMenu ? (menu.style.width = shortMenu + 'px') : (menu.style.width = bigMenu + 'px')
    },
    resizeWatch () {
      let menu = document.querySelector('.left-panel')
      if (window.innerWidth < 1000) menu.style.width = '65px'
      window.addEventListener('resize', () => {
        let xLength = window.innerWidth
        let breakPoint = 1000
        xLength < breakPoint
          ? (menu.style.width = '65px')
          : (menu.style.width = '235px')
      })
    },
    isActive () {
      this.active = !this.active
    }
  },
  computed: {},
  components: {},
  watch: {}
}
</script>
<style lang="scss" scoped>
.active {
  i,
  a {
    color: $white !important;
  }
}
.first-nav {
  font-size: 1em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: #808080;
  a,
  i {
    color: #808080;
    width: 35px;
  }
}

.hidden-nav {
  white-space: nowrap;
  overflow: hidden;
  /*text-overflow: ellipsis;*/
}

.subMenu {
  margin: 15px 0;
  i {
    font-style: normal;
    cursor: pointer;
  }
  &:hover {
    i,
    a {
      color: white;
    }
  }
}
.shrinkHide {
  transition: all 2000ms ease-in !important;
}
</style>
